import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { actions } from "../../actions/actionsWrapper";
import { eFoDotDangKyAnActionTypeIds, IFoDotDangKyAnActionTypes } from "../../action-types/thuc-don/IFoDotDangKyAnActionTypes";
import { IBaseResponeModel } from "../../../models/response/base-response";

export function* foDotDangKyAnSaga(): any {
    yield takeLatest(eFoDotDangKyAnActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eFoDotDangKyAnActionTypeIds.LOAD_BY_COSO_NAMHOC_START, loadByCoSoNamHocWorker)
    yield takeEvery(eFoDotDangKyAnActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFoDotDangKyAnActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(): any {
    try {
        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dotDangKyAn.select_all);
        if (res.is_success) {
            yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_SUCCESS(res.data));
        } else {
            yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_ERROR(error.message ?? "Unexpected error occurred"));
    }
}

function* loadByCoSoNamHocWorker(action: IFoDotDangKyAnActionTypes): any {
    try {
        const payload = action.payload as { dm_coso_id: number; nam_hoc: string };

        if (!payload || !payload.dm_coso_id || !payload.nam_hoc) {
            yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_BY_COSO_NAMHOC_ERROR("Invalid parameters"));
            return;
        }

        const res: IBaseResponeModel = yield call(
            apiWrapper.thucDonWrapper.dotDangKyAn.select_by_coso_namhoc,
            payload.dm_coso_id,
            payload.nam_hoc
        );

        if (res.is_success) {
            yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_BY_COSO_NAMHOC_SUCCESS(res.data));
        } else {
            yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_BY_COSO_NAMHOC_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_BY_COSO_NAMHOC_ERROR(error.message ?? "Unexpected error occurred"));
    }
}

function* saveWorker(action: IFoDotDangKyAnActionTypes): any {
    try {
        const payload = action.payload as any; // Sử dụng any để hỗ trợ IFoDotDangKyAnWithScope

        if (!payload) {
            yield put(actions.thucDonWrapper.dotDangKyAn.SAVE_ERROR("Invalid payload"));
            return;
        }

        // Gọi API saveChanges thay vì insert/update
        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dotDangKyAn.saveChanges, payload);

        if (res.is_success) {
            yield put(actions.thucDonWrapper.dotDangKyAn.SAVE_SUCCESS(res.data));
            // Reload data sau khi lưu thành công
            yield put(actions.thucDonWrapper.dotDangKyAn.LOAD_START(undefined));
        } else {
            yield put(actions.thucDonWrapper.dotDangKyAn.SAVE_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dotDangKyAn.SAVE_ERROR(error.message ?? "Unexpected error occurred"));
    }
}

function* deleteWorker(action: IFoDotDangKyAnActionTypes): any {
    try {
        const id: number = action.payload as number;

        if (!id || id <= 0) {
            yield put(actions.thucDonWrapper.dotDangKyAn.DELETE_ERROR("Invalid ID"));
            return;
        }

        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dotDangKyAn.delete, id);

        if (res.is_success) {
            yield put(actions.thucDonWrapper.dotDangKyAn.DELETE_SUCCESS(undefined));
        } else {
            yield put(actions.thucDonWrapper.dotDangKyAn.DELETE_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dotDangKyAn.DELETE_ERROR(error.message ?? "Unexpected error occurred"));
    }
}
